export const OBJECT_TYPES = {
  Alertdefinition: {appLabel: "alerts", model: "alertdefinition"},
  Logentry: {appLabel: "admin", model: "logentry"},
  Permission: {appLabel: "auth", model: "permission"},
  Group: {appLabel: "auth", model: "group"},
  User: {appLabel: "auth", model: "user"},
  Contenttype: {appLabel: "contenttypes", model: "contenttype"},
  Session: {appLabel: "sessions", model: "session"},
  Site: {appLabel: "sites", model: "site"},
  Crontabschedule: {appLabel: "django_celery_beat", model: "crontabschedule"},
  Intervalschedule: {appLabel: "django_celery_beat", model: "intervalschedule"},
  Periodictask: {appLabel: "django_celery_beat", model: "periodictask"},
  Periodictasks: {appLabel: "django_celery_beat", model: "periodictasks"},
  Solarschedule: {appLabel: "django_celery_beat", model: "solarschedule"},
  Clockedschedule: {appLabel: "django_celery_beat", model: "clockedschedule"},
  Token: {appLabel: "authtoken", model: "token"},
  Tokenproxy: {appLabel: "authtoken", model: "tokenproxy"},
  Appliancecategory: {appLabel: "core", model: "appliancecategory"},
  Sensortype: {appLabel: "core", model: "sensortype"},
  Sensorgroup: {appLabel: "core", model: "sensorgroup"},
  Aquaticgroupprofile: {appLabel: "core", model: "aquaticgroupprofile"},
  Baseaddress: {appLabel: "organization", model: "baseaddress"},
  Basecontactperson: {appLabel: "organization", model: "basecontactperson"},
  Customer: {appLabel: "organization", model: "customer"},
  Organization: {appLabel: "organization", model: "organization"},
  Organizationprofile: {appLabel: "organization", model: "organizationprofile"},
  Organizationuser: {appLabel: "organization", model: "organizationuser"},
  Customeraddress: {appLabel: "organization", model: "customeraddress"},
  Customercontactperson: {appLabel: "organization", model: "customercontactperson"},
  Organizationcontactperson: {
    appLabel: "organization",
    model: "organizationcontactperson",
  },
  Organizationuserarea: {appLabel: "organization", model: "organizationuserarea"},
  Organizationsettings: {appLabel: "organization", model: "organizationsettings"},
  Organizationowner: {appLabel: "organization", model: "organizationowner"},
  Organizationbranding: {appLabel: "organization", model: "organizationbranding"},
  Organizationaddress: {appLabel: "organization", model: "organizationaddress"},
  Location: {appLabel: "organization", model: "location"},
  Customeraddressmap: {appLabel: "organization", model: "customeraddressmap"},
  Profile: {appLabel: "accounts", model: "profile"},
  Authtoken: {appLabel: "accounts", model: "authtoken"},
  Notification: {appLabel: "notification", model: "notification"},
  Baseunits: {appLabel: "system", model: "baseunits"},
  Fieldchoices: {appLabel: "system", model: "fieldchoices"},
  Fieldconverter: {appLabel: "system", model: "fieldconverter"},
  Fielddefinition: {appLabel: "system", model: "fielddefinition"},
  Iopinpool: {appLabel: "system", model: "iopinpool"},
  Lan: {appLabel: "system", model: "lan"},
  Portforwarding: {appLabel: "system", model: "portforwarding"},
  Sensor: {appLabel: "system", model: "sensor"},
  Sensormetadata: {appLabel: "system", model: "sensormetadata"},
  Sensormodel: {appLabel: "system", model: "sensormodel"},
  Sensorpagesection: {appLabel: "system", model: "sensorpagesection"},
  Systeminventory: {appLabel: "system", model: "systeminventory"},
  Systemproduct: {appLabel: "system", model: "systemproduct"},
  Systemproperties: {appLabel: "system", model: "systemproperties"},
  Systemprofile: {appLabel: "system", model: "systemprofile"},
  Sensorproperties: {appLabel: "system", model: "sensorproperties"},
  Inventorysensors: {appLabel: "system", model: "inventorysensors"},
  Inventoryalarms: {appLabel: "system", model: "inventoryalarms"},
  Systeminventoryfav: {appLabel: "system", model: "systeminventoryfav"},
  Sensorcalibration: {appLabel: "system", model: "sensorcalibration"},
  Powerchannel: {appLabel: "system", model: "powerchannel"},
  Inventorypowerchannel: {appLabel: "system", model: "inventorypowerchannel"},
  Alertnotification: {appLabel: "alerts", model: "alertnotification"},
  Sensoralertdefinition: {appLabel: "alerts", model: "sensoralertdefinition"},
  Manualresulttemplate: {appLabel: "reports", model: "manualresulttemplate"},
  Reporttemplate: {appLabel: "reports", model: "reporttemplate"},
  Report: {appLabel: "reports", model: "report"},
  Webhook: {appLabel: "extras", model: "webhook"},
  Webhookdelivery: {appLabel: "extras", model: "webhookdelivery"},
  Customfieldchoiceset: {appLabel: "extras", model: "customfieldchoiceset"},
  Customfield: {appLabel: "extras", model: "customfield"},
};
